import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { ConfigAssDigitalCondominioDTO } from "types/dto/groupsign/ConfigAssDigitalCondominioDTO";

export const useGetConfigAssDigitalCondominioPorUuid = (uuid: string) => {
  return useFetch<ConfigAssDigitalCondominioDTO>({
    key: ["get-config-ass-digital-por-uuid", uuid],
    url: `${api.groupsign.configuracaoAssinaturaDigital}/${uuid}`,
  });
};
